const actionTypeIdentifier = '8E41E392 - F984 - 497A - A109 - E9A67947B256';

export const setDefaultArticleCatalogue = `SET-DEFAULT-ARTICLE-CATALOGUE-${actionTypeIdentifier}`;
export const getArticleCatalogue = `GET-ARTICLE-CATALOGUE-${actionTypeIdentifier}`;
export const sortArticleCatalogueItems = `SORT-ARTICLE-CATALOGUE-ITEMS-${actionTypeIdentifier}`
export const setArticleCatalogueColSearchStr = `SORT-ARTICLE-CATALOGUE-COL-SEARCH-STR${actionTypeIdentifier}`;
export const setArticleCataloguePageSize = `SET-ARTICLE-CATALOGUE-PAGE-SIZE-${actionTypeIdentifier}`;
export const setArticleCatalogueError = `SET-ARTICLE-CATALOGUE-ERROR-${actionTypeIdentifier}`;
export const setArticleCatalogueFilter = `SET-ARTICLE-CATALOGUE-FILTER-${actionTypeIdentifier}`;
export const applyArticleCatalogueFilter = `APPLY-ARTICLE-CATALOGUE-FILTER-${actionTypeIdentifier}`;